import { StyleSheet } from 'react-native';

import Button from '../../../../Components/Button';
import List from '../../../../Components/List';
import { numberToArray } from '../../../../Helper';
import ThemeColor from '../../../../Theme/colors';

type Props = {
  activeIndex: number;
  count: number;
  onPress: (index: number) => void;
};

const Pagination = ({ activeIndex, count, onPress }: Props) => {
  return (
    <List
      data={numberToArray(count)}
      renderItem={({ _, index }) => (
        <Button
          hitSlop={10}
          style={[
            styles.dot,
            {
              backgroundColor:
                index === activeIndex
                  ? `${ThemeColor.darkGray}DB`
                  : `${ThemeColor.gray}AD`,
            },
          ]}
          onPress={() => onPress(index)}
          plain
        />
      )}
      horizontal
    />
  );
};

export const styles = StyleSheet.create({
  dot: {
    marginHorizontal: 2.5,
    width: 11,
    height: 11,
    borderRadius: 6,
  },
});

export default Pagination;
